$(document).ready(function(){
	init(); 
	$(window).trigger('scroll');
	$(window).trigger('resize');
});

function init(){
	//Nav
	$(window).on('scroll', function() {
		var headerHeight = ($('header').outerHeight() / 2);

		if ( $(window).scrollTop() > headerHeight ) {
			$('header').addClass('header__fixed-bg');
		} else {
			$('header').removeClass('header__fixed-bg');
		}
	});

	//Modals
	$('.modals').addClass('loaded');

	$(document).on('click', '.js__modal-trigger', function(e) {
		e.preventDefault();
		var modal = $(this).data('modal');
		var space = $(this).data('space');

		if ( space ) {
			$('#modal_form #modal_space').val(space);
			$('#modal_form #modal_booking_type').val('event');
			$('.js__booking-selectric').selectric('refresh');
		}

		//Show modal
		$('.modals .modal__item').removeClass('showing');
		$('.modals .js__modal-close').show();
		$('.modals').addClass('open');
		$('.modals .modal__item#'+modal).addClass('open showing');

		if($(this).attr('href') != undefined){
			window.location.href = $(this).attr('href');
		}
	});

	$('.js__modal-close').on('click', function(e) {
		e.preventDefault();

		$('.modals').removeClass('open');
		$('.modals .modal__item').removeClass('open');	

		// If closing announcement modal, create hide_announcement cookie
		if ($(this).closest('#announcement').length) {
			var urlBasePath = window.location.pathname.split('/')[1]; // e.g. Gets 'the-folly' from full url.
			setCookie('hide_announcement', 'true', 100, urlBasePath);

			if($(this).attr('href') != undefined){
				window.location.href = $(this).attr('href');
			}
		}
	});

	console.log(getCookie('hide_announcement'));
	if(getCookie('hide_announcement')){ 
		$('.modals').removeClass('open'); 
	}

	//Check to trigger modal on page load
	if(window.location.href.indexOf("#") != -1){
		let hashVal = window.location.href.split('#')[1];
		if(hashVal){
			let modalElement = $('.modals .modal__item#'+hashVal);
			if(modalElement){
				//Show modal
				$('.modals .modal__item').removeClass('showing');
				$('.modals .js__modal-close').show();
				$('.modals').addClass('open');
				modalElement.addClass('open showing');
			}
		}
		
	}

	//Popups
	$('.popup').addClass('loaded');

	// Menu Popup
	$(document).on('click', '.js__nav-trigger', function(e) {
		e.preventDefault();
		var popup = $(this).data('popup');

		if ( !$(this).hasClass('active') ) {
			openPopup(popup);
			openNavPopupAnimation();		
		} else {
			closePopupAnimation();	
		}

		if ( $(window).width() < 575 ) {
			$(this).toggleClass('active');
		}
	});		

	// Booking Popup
	$(document).on('click', '.js__booking-trigger, .booking-button', function(e) {
		e.preventDefault();
		var bookingButton = $('header .resy__button >span');
		bookingButton.trigger('click');
	});	

	$(document).on('click', '.js__vacancies-link, .vacancies-link', function(e) {
		e.preventDefault();
		var popup = 'vacancies';

		openPopup(popup);
		openVacanciesPopupAnimation();
	});

	$(document).on('click', '.js__popup-trigger', function(e) {
		e.preventDefault();
		var popup = $(this).data('popup');

		openPopup(popup);
	});	

	$('.js__popup-close').on('click', function(e) {
		e.preventDefault();

		closePopupAnimation();
	});			

	function openPopup(popup) {
		$('.popup .popup__item').removeClass('showing');
		$('.popup .js__popup-close').show();
		$('html, body').css('overflow', 'hidden');

		$('.popup').addClass('open');
		$('.popup .popup__item#'+popup).addClass('open showing');

		if ( popup == 'nav' ) {
			openNavPopupAnimation();
		}
	}

	function closePopupAnimation() {
		var tl;
		tl = gsap.timeline();
		tl.to('.popup', {duration: 0.4, opacity: 0, onComplete: closePopup});
	}

	function closePopup() {
		$('.popup').removeClass('open');
		$('.popup').removeClass('nav-popup');
		$('.popup .popup__item').removeClass('open');
		$('.popup .popup__item-nav-image-container').removeClass('animate');

		$('html, body').removeAttr('style');
	}

	function openNavPopupAnimation() {
		var tl;
		tl = gsap.timeline();
		tl.to('.popup', {duration: 0.4, opacity: 1});
		tl.from('.js__popup-close', {
			duration: 0.4, 
			opacity: 0,
			onComplete: animatePopupImage}
		);
		tl.addLabel('navItems');
		tl.from('.popup__item.open .popup__item-nav .menu >.menu-item', {
			duration: 0.6, 
			y: 30, 
			opacity: 0, 
			stagger: -0.1}, 'navItems'
		);
	}	

	function animatePopupImage() {
		$('.popup.open .popup__item-nav-image-container').addClass('animate');
	}

	$(document).keyup(function(e) {
  		if (e.keyCode === 27) { // esc
  			if ( $('.popup').hasClass('open') ) {
  				closePopupAnimation();
  			}
  		}
	});	

	//Popup Nav Item - Dropdown
	$(document).on('click', '.popup .popup__item-nav .menu-item.menu-item-has-children >a', function(e) {
		if ( !$(this).hasClass('sub-menu-showing') ) {
			e.preventDefault();
			$(this).siblings('.sub-menu').slideDown();
			$(this).addClass('sub-menu-showing');
		}
	});

	//Image Slider
	var imageSliderIndex = 1; $('.js__image-slider').each(function() {
		var sliderControls = $(this).siblings('.c__image-slider-controls');

		$(this).addClass('js__image-slider-'+imageSliderIndex);

		if ( sliderControls.find('.js__image-slider-captions').length ) {
			sliderControls.find('.js__image-slider-captions').addClass('js__image-slider-captions-'+imageSliderIndex);
		}	
	
		$('.js__image-slider-'+imageSliderIndex).not('.slick-initialized').slick({
			arrows: true,
			appendArrows: sliderControls.find('.c__slick-arrows'),
			nextArrow: sliderControls.find('.slick-next'),
			prevArrow: sliderControls.find('.slick-prev'),
			dots: true,
			appendDots: sliderControls.find('.c__slick-dots')
		});

		if ( sliderControls.find('.js__image-slider-captions').length ) {
			$('.js__image-slider-'+imageSliderIndex).slick('slickSetOption', 'asNavFor', $('.js__image-slider-captions-'+imageSliderIndex), true);

			$('.js__image-slider-captions-'+imageSliderIndex).not('.slick-initialized').slick({
				arrows: false,
				dots: false,
				draggable: false,
				fade: true
			});
		}

		imageSliderIndex++;
	});	

	//Grid Slider
	var gridSliderIndex = 1; $('.js__grid-slider').each(function() {
		var sliderControls = $(this).siblings('.c__image-slider-controls');

		$(this).addClass('js__grid-slider-'+gridSliderIndex);
	
		$('.js__grid-slider-'+gridSliderIndex).not('.slick-initialized').slick({
			infinite: false,
			autoplay: false,
			slidesToShow: 4,
			arrows: true,
			appendArrows: sliderControls.find('.c__slick-arrows'),
			nextArrow: sliderControls.find('.slick-next'),
			prevArrow: sliderControls.find('.slick-prev'),
			dots: true,
			appendDots: sliderControls.find('.c__slick-dots'),
		  	responsive: [
			    {
		      		breakpoint: 991,
		      		settings: {
			        	slidesToShow: 3
			      	}
			    },
			    {
		      		breakpoint: 575,
		      		settings: {
			        	slidesToShow: 1
		      		}
			    }
		    ]
		});

		gridSliderIndex++;
	});	

	//Selectric
	$('.js__selectric-newsletter').selectric();
	$('.js__selectric-whats-on--type').selectric();
	$('.js__selectric-whats-on--type').on('change', function() {
		var typeSelected = $(this).val();
		var content = $('.whats__on-posts');

	    // Set min height for the content
	    var minHeight = content.outerHeight();
	    content.css('min-height', minHeight+'px');	

		$('.whats__on-post-col').fadeOut(400);

		setTimeout(function() {
			if ( typeSelected == 'all' ) {
				$('.whats__on-post-col').removeClass('hide');
			} else {
				$('.whats__on-post-col').each(function(e) {
					var eventType = $(this).data('event-type');

					if ( eventType != typeSelected ) {
						$(this).addClass('hide');
					} else {
						$(this).removeClass('hide');
					}
				});		
			}
			
			$('.whats__on-post-col').not('.hide').fadeIn();
			content.removeAttr('style');
		}, 550);
	});

	//Booking Form
	$('.js__booking-selectric').selectric();

	function formatDate(number) {
		if ( number < 10 ) {
			return '0' + number;
		} else {
			return number;
		}
	}

	$('.js__pikaday-trigger').each(function() {
		var fieldID =  $(this).attr('id');
		var bookingDate = new Pikaday({
		    field: document.getElementById(fieldID),
		    format: 'DD/MM/YYYY',    
		    minDate: new Date(2020, 3, 21),
		    onSelect: function(date) {
		        var day = date.getDate();
		        var month = formatDate(date.getMonth());
		        var year = formatDate(date.getFullYear());	           	
			}
		});
	});

    $(".inline-widget__container #dmn-type option:first").html("Select a booking type");
    $(".modal-widget__container #dmn-type option:first").html("Select a booking type");
    $(".inline-widget__container .dmn-num-people-container select option:first").html("Select an amount of people");
    $(".modal-widget__container .dmn-num-people-container select option:first").html("Select an amount of people");
    $(".inline-widget__container #dmn-num-people").attr("placeholder", "Select an amount of people");
    $(".modal-widget__container #dmn-num-people").attr("placeholder", "Select an amount of people");
    $(".inline-widget__container #dmn-date").attr("placeholder", "Select a date");
    $(".modal-widget__container #dmn-date").attr("placeholder", "Select a date");
    $(".inline-widget__container #dmn-time option:first").html("Select a time");
    $(".modal-widget__container #dmn-time option:first").html("Select a time");
    $(".dmn-form button.submit").html("Confirm Booking");
    $(".inline-widget__container .dmn-form button.submit").attr('id', 'inline-book-a-table');
    $(".modal-widget__container .dmn-form button.submit").attr('id', 'modal-book-a-table');
    // Class Names
    $(".dmn-form .main-inputs").addClass('row align-items-center');
    $(".inline-widget__container .dmn-form label").addClass('colour__primary');
    $(".dmn-form .main-inputs >div").not('.dmn-overlay').addClass('col-12 col-md-6 col-lg-4 dmn-form-elem');
    $(".inline-widget__container .dmn-form .main-inputs >div").not('.dmn-overlay').addClass('colour__primary');
    $(".inline-widget__container .dmn-form .main-inputs .dmn-date-container input").addClass('colour__primary');
    $(".dmn-form button.submit").removeClass('btn btn-primary').addClass('c__btn');
    $(".inline-widget__container .dmn-form button.submit").addClass('button__primary');

	//Our Favourites
	if ( $('.js__menu-favourites-slider').length ) {
		$favouritesSlider = $('.js__menu-favourites-slider');
		settings = {
			arrows: true,
			appendArrows: $('.menu__favourites-arrows'),
			nextArrow: $('.menu__favourites-arrows .slick-next'),
			prevArrow: $('.menu__favourites-arrows .slick-prev'),
			dots: true,
			appendDots: $('.menu__favourites-dots'),		
		};
		$favouritesSlider.slick(settings);

		// reslick only if it's not slick()
		$(window).on('resize', function() {
			if ( $(window).width() > 767 ) {
				if ($favouritesSlider.hasClass('slick-initialized')) {
					$favouritesSlider.slick('unslick');
				}
				return;
			}

			if ( $(window).width() < 767 ) {
				if (!$favouritesSlider.hasClass('slick-initialized')) {
					return $favouritesSlider.slick(settings);
				}
			}
		});		
	}	

	// Menus Functions
	if ( document.querySelector('.menus__section') ) {		
		$('.js__selectric--menus').selectric({
			nativeOnMobile: false
		});
		$('.js__selectric--menus').selectric().on('change', function() {
			var menuID = $(this).val();
			ajaxMenus(menuID);
		});
	
		// AJAX Change Menus
		$(document).on('click', '.js__menu-trigger', function(e) {
			e.preventDefault();

			if ( !$(this).hasClass('active') ) {
				var menuID = $(this).data('menu');

				$('.js__menu-trigger').removeClass('active');
				$(this).addClass('active');

				ajaxMenus(menuID);
			}
		});

		// Calorie Counter Functions
		var calorieCounterTrigger = document.querySelector('.js__cc-trigger');

		if ( calorieCounterTrigger ) {
			calorieCounterTrigger.addEventListener('click', (e) => {
				e.preventDefault();

				calorieCounterTrigger.classList.toggle('active');

				// Toggle the showing class on all menu item calorie elems
				var calorieElems = document.querySelectorAll('.menu__item-calories');

				if ( calorieElems ) {
					calorieElems.forEach(elem => {
						elem.classList.toggle('showing');
					});
				}
			});
		}

		// Create the filter variable
		var activeFilterSection = 'allergens';
		var minCalories = 0;
		var maxCalories = 0;
		var dietaryFiltersArr = [];
		var allergenFiltersArr = [];

		// Show/Hide the filters
		var filterTriggers = document.querySelectorAll('.js-toggle-filters');
		if ( filterTriggers ) {
			filterTriggers.forEach(trigger => {
				trigger.addEventListener('click', (e) => {
					e.preventDefault();

					// Open/Close the filter Elem
					toggleFilter();
				});
			});
		}

		function toggleFilter() {
			var filterElem = document.querySelector('.menu__filter--dietary');

			// Toggle the open class on the triggers
			document.querySelector('.js-toggle-filters.menu__filter-label').classList.toggle('open');

			// Open/Close the filter Elem
			filterElem.classList.toggle('open');
		}

		// Switch between the two types of filter sections
		var filterSectionTrigger = document.querySelector('.js__switch-filters');
		if ( filterSectionTrigger ) {
			filterSectionTrigger.addEventListener('click', (e) => {
				e.preventDefault();

				// Toggle the active state of the trigger
				filterSectionTrigger.classList.toggle('active');

				// Work out which section we should now be showing
				var filterType = activeFilterSection === 'allergens' ? 'calories' : 'allergens';

				// Update the section
				changeSection(filterType);

				// Update the activeFilterSection variable
				activeFilterSection = filterType;
			});
		}

		function changeSection(filterType) {
			document.querySelectorAll('.menu__filter-section').forEach(section => {
				section.classList.add('d-lg-none');
			});
			document.querySelector('.menu__filter-section[data-filter-section="' + filterType + '"]').classList.remove('d-lg-none');
		}    

		// Build up the filters
		var menuFilterTriggers = document.querySelectorAll('.js__menu-filter-trigger');
		if ( menuFilterTriggers ) {
			menuFilterTriggers.forEach(trigger => {
				trigger.addEventListener('click', (e) => {
					e.preventDefault();

					// Toggle the active state
					trigger.classList.toggle('active');

					// Check if we are activating the filter or removing it
					var isActive = trigger.classList.contains('active');

					// Add/Remove the filter to the dietaryFiltersArr or allergenFiltersArr array depending on the filter type
					var filterType = trigger.getAttribute('data-filter-type');
					var filter = trigger.getAttribute('data-requirement');

					updateActiveFilters(filterType, filter, isActive);

					// Update the menu items based on filters
					updateMenuItems();
				});
			});
		}
		// Build up filters -- mobile
		$('.js__selectric--diet').selectric({
			nativeOnMobile: false
		});
		$('.js__selectric--diet').selectric().on('change', function() {
			var activeFilters = $(this).val();
	
			//Remove empty item added if first placeholder item is selected
			var emptyItemIndex = activeFilters.indexOf("");
			if (emptyItemIndex > -1) {
				activeFilters.splice(emptyItemIndex, 1);
			}
	
			// Update the dietaryFiltersArr array
			dietaryFiltersArr = activeFilters;

			// Update the menu items based on filters
			updateMenuItems();
		});  
    	$('.js__selectric--allergens').selectric({
			nativeOnMobile: false
		});
		$('.js__selectric--allergens').selectric().on('change', function() {
			var activeFilters = $(this).val();
	
			//Remove empty item added if first placeholder item is selected
			var emptyItemIndex = activeFilters.indexOf("");
			if (emptyItemIndex > -1) {
				activeFilters.splice(emptyItemIndex, 1);
			}
	
			// Update the dietaryFiltersArr array
			allergenFiltersArr = activeFilters;

			// Update the menu items based on filters
			updateMenuItems();
		});  

		function updateActiveFilters(filterType, filter, isActive) {
			if ( filterType === 'dietary' ) {
				if ( isActive ) {
					// Add ttem to the array
					dietaryFiltersArr.push(filter);
				} else {
					// Remove item from the array
					var filterIndex = dietaryFiltersArr.indexOf(filter);
					if ( filterIndex > -1 ) {
						  dietaryFiltersArr.splice(filterIndex, 1);
					}							
				}
			}
			if ( filterType === 'allergen' ) {
				if ( isActive ) {
					// Add ttem to the array
					allergenFiltersArr.push(filter);
				} else {
					// Remove item from the array
					var filterIndex = allergenFiltersArr.indexOf(filter);
					if ( filterIndex > -1 ) {
						  allergenFiltersArr.splice(filterIndex, 1);
					}							
				}
			}
		}

		function updateMenuItems() {
			var menuItems = document.querySelectorAll('.menu__item');
			var filtersActive = dietaryFiltersArr.length || allergenFiltersArr.length;

			if ( menuItems ) {
				menuItems.forEach(item => {
					// If no filters are set, set showItem to true
					var showItem = filtersActive ? false : true;

					// Decide which items to show if filters are active
					if ( filtersActive ) {
						var itemDietaryFilters = JSON.parse(item.getAttribute('data-dietary-filters'));
						var itemAllergenFilters = JSON.parse(item.getAttribute('data-allergen-filters'));
	
						// Check if item has dietary filter
						if ( dietaryFiltersArr.length ) {
							itemDietaryFilters.every(dietaryRequirement => {
								if ( dietaryFiltersArr.includes(dietaryRequirement) ) {
									showItem = true;
									return false;
								}
	
								return true;
							});
						} else {
							showItem = true;
						}
	
						// Check if the item contains any of the active allergen filters
						if ( allergenFiltersArr.length ) {
							itemAllergenFilters.every(allergen => {
								if ( allergenFiltersArr.includes(allergen) ) {
									showItem = false;
									return false;
								}
	
								return true;
							});
						}
					}

					// Check if the items fall between the calorie filter
					if ( showItem ) {
						var calories = parseInt(item.getAttribute('data-calories'));
						showItem = calories >= minCalories && calories <= maxCalories;
					}

					if ( showItem ) {
						item.classList.remove('fade-out');
					} else {
						item.classList.add('fade-out');
					}
				});
			}
		}

		// Menu Section Slider Init
		function initMenuSectionSlider() {
			var menuSectionSlider = document.querySelector('.js__menu-sections-list-slider');
			if ( menuSectionSlider ) {
				$('.js__menu-sections-list-slider').not('.slick-initialized').slick({
					mobileFirst: true,
					arrows: false,
					slidesToShow: 1,
					swipeToSlide: true,
					responsive: [
						{
						breakpoint: 575,
						settings: {
							slidesToShow: 2
						}
						},
						{
						breakpoint: 767,
						settings: {
							slidesToShow: 3
						}
						},
						{
						breakpoint: 1199,
						settings: {
							slidesToShow: 4
						}
						},
						{
						breakpoint: 1399,
						settings: {
							slidesToShow: 5
						}
						}
					]
				});
			
				var menuSectionNextTrigger = document.querySelector('.js__menu-sections-list-slider-next');
				var menuSectionPrevTrigger = document.querySelector('.js__menu-sections-list-slider-prev');
				if ( menuSectionNextTrigger ) {
					menuSectionNextTrigger.addEventListener('click', (e) => {
						e.preventDefault();
			
						$('.js__menu-sections-list-slider').slick('slickNext');
					});
				}
				if ( menuSectionPrevTrigger ) {
					menuSectionPrevTrigger.addEventListener('click', (e) => {
						e.preventDefault();
			
						$('.js__menu-sections-list-slider').slick('slickPrev');
					});
				}
			}
	
			// Scroll to menu section functionality
			var menuSectionScrollTriggers = document.querySelectorAll('.js__scroll-to-menu-section');
			if ( menuSectionScrollTriggers ) {
				menuSectionScrollTriggers.forEach(trigger => {
					trigger.addEventListener('click', (e) => {
						e.preventDefault();
				
						var triggerMenuSection = trigger.getAttribute('data-menu-section');
						var menuSection = document.querySelector('.menu__section[data-menu-section="'+triggerMenuSection+'"]');
			
						var headerOffset = document.querySelector('header.header').offsetHeight;
						var menuSectionOffset = document.querySelector('.menu__sections-list') ? document.querySelector('.menu__sections-list').offsetHeight : 0;
						var totalOffset = headerOffset + menuSectionOffset + 30;
						var elementPosition = menuSection.getBoundingClientRect().top;
						var offsetPosition = elementPosition + window.pageYOffset - totalOffset;
					
						window.scrollTo({
							top: offsetPosition,
							behavior: "smooth"
						});
					});
				});
			}
		}

		// Menu Icon Tooltips
		function initTooltip(trigger, tooltip) {
			const popperInstance = Popper.createPopper(trigger, tooltip, {
				placement: 'top',
				modifiers: [{
					name: 'offset',
					options: {
						offset: [0, 16],
					},
				}]
			});
	
			function show() {
				// Make the tooltip visible
				tooltip.setAttribute('data-show', '');
				tooltip.classList.remove('d-none');

				// Enable the event listeners
				popperInstance.setOptions((options) => ({
					...options,
					modifiers: [
						...options.modifiers,
						{ name: 'eventListeners', enabled: true },
					],
				}));

				// Update its position
				popperInstance.update();
			}
	
			function hide() {
				// Hide the tooltip
				tooltip.removeAttribute('data-show');
				tooltip.classList.add('d-none');

				// Disable the event listeners
				popperInstance.setOptions((options) => ({
					...options,
					modifiers: [
						...options.modifiers,
						{ name: 'eventListeners', enabled: false },
					],
				}));
			}
	
			const showEvents = ['mouseenter', 'focus'];
			const hideEvents = ['mouseleave', 'blur'];
		
			showEvents.forEach((event) => {
				trigger.addEventListener(event, show);
			});
		
			hideEvents.forEach((event) => {
				trigger.addEventListener(event, hide);
			}); 
		}
  
		// Loop through each tooltip and run the init function
		function initTooltips() {
			const tooltipWrapperElems = document.querySelectorAll('.js__tooltip-wrapper');
			
			if ( tooltipWrapperElems ) {
				tooltipWrapperElems.forEach(elem => {
					const trigger = elem.querySelector('.js__tooltip-trigger');
					const tooltip = elem.querySelector('.js__tooltip');
			
					initTooltip(trigger, tooltip);
				});
			}
		}
    
		// Calorie Range Functions
		function initCalorieRangeElem() {
			var calorieRangeElem = document.querySelector('.js__calorie-range');
			var maxRange = calorieRangeElem && calorieRangeElem.getAttribute('data-max-calories') ? parseInt(calorieRangeElem.getAttribute('data-max-calories')) : 0;

			// Update th max calories variable
			maxCalories = maxRange;

			if ( calorieRangeElem ) {
				noUiSlider.create(calorieRangeElem, {
					start: [0, 2000],
					range: {
						'min': 0,
						'12.5%': (maxRange / 8) * 1,
						'25%': (maxRange / 8) * 2,
						'37.5%': (maxRange / 8) * 3,
						'50%': (maxRange / 8) * 4,
						'62.5%': (maxRange / 8) * 5,
						'75%': (maxRange / 8) * 6,
						'87.5%': (maxRange / 8) * 7,
						'max': maxRange
					},
					snap: true,
					pips: {
						mode: 'range',
						density: 0
					},
					margin: 12.5,
					tooltips: [wNumb({decimals: 0}), wNumb({decimals: 0})]
				});
		
				calorieRangeElem.noUiSlider.on('set', function (values, handle) {
					// Update the min and max calories variables
					minCalories = Math.ceil(values[0]);
					maxCalories = Math.ceil(values[1]);
			
					// Call the updateMenuItems function
					updateMenuItems();
					
					// Update the min and max calories text
					document.querySelector('.menu__filter-min-calories').innerHTML = Math.ceil(values[0]);
					document.querySelector('.menu__filter-max-calories').innerHTML = Math.ceil(values[1]);
				});
			}
		}

		// Call the functions
		initMenuSectionSlider();
		initTooltips();
		initCalorieRangeElem();

		function ajaxMenus(menuID) {
			var filterElem = document.querySelector('.menu__filter--dietary');
			var menuSections = document.querySelector('.menu__sections-list');
			var content = $('#menus_ajax_container');

			$.ajax({
				type: 'POST',
				dataType: 'html',
				url: main__js_vars.ajaxurl,
				data: {
					'menuID': menuID,
					'action': 'ajax_menus'
				},
				beforeSend : function () {
					// Close the filter
					document.querySelector('.js-toggle-filters.menu__filter-label').classList.remove('open');
					filterElem.classList.remove('open');

					// Set the allergens to be the default to display
					changeSection('allergens');

					// Clear Filters
					clearFilters();

					// Check if menu sections exists
					if ( menuSections ) {
						// Set the min height for the menuSections elem
						var menuSectionsMinHeight = menuSections.offsetHeight;
						menuSections.style.minHeight = menuSectionsMinHeight + 'px';

						// Fade out the menuSections elem
						menuSections.classList.add('fading-out');
					}

					// Set the calorie trigger to false
					document.querySelector('.js__cc-trigger').classList.remove('active');
					
					// Set min height for the content
					var contentMinHeight = content.outerHeight();
					content.css('min-height', contentMinHeight+'px');

					// Fade out the content
					content.addClass('fading-out');
				},
				success: function (data) {
					var returnedData = JSON.parse(data);

					// Allergens Filter
					if ( returnedData.hide_allergen_filters ) {
						// Hide the allergens filter
						document.querySelector('.js-filter-section[data-filter-section="allergens"]').classList.add('d-none');
					} else {
						// Show the allergens filter
						document.querySelector('.js-filter-section[data-filter-section="allergens"]').classList.remove('d-none');
					}

					// Icon Keys
					if ( returnedData.hide_allergen_icons ) {
						document.querySelector('.menu__filter-icon-keys').classList.add('fading-out');
					} else {
						document.querySelector('.menu__filter-icon-keys').classList.remove('fading-out');
					}

					// Menu Sections
					$('.js__menu-sections-list-slider').slick('unslick');
          
					if ( returnedData.menu_sections ) {
						// Show this again if previously hidden
						menuSections.classList.remove('d-none');
						
						// Update menuSections items
						menuSections.querySelector('.menu__sections-list-items').innerHTML = returnedData.menu_sections;
								} else {
						// Clear previous items
						menuSections.querySelector('.menu__sections-list-items').innerHTML = '';
						
						// Hide the menuSections elem
						menuSections.classList.add('d-none');
					}

					// Calories
					if ( returnedData.calories_filter_section ) {
						// Update the calories range html with the returned value
						document.querySelector('.js-calories-filter-section').innerHTML = returnedData.calories_filter_section;

						// Show the calories filter button
						document.querySelector('.js__calories-filter-menu-item').classList.remove('d-none');

						// Show the calories counter toggle
						document.querySelector('.menu__filter-cc-container').classList.remove('fading-out');

						// Re-call the calorie range function
						initCalorieRangeElem();
					} else {
						// Hide the calories filter button
						document.querySelector('.js__calories-filter-menu-item').classList.add('d-none');

						// Hide the calories counter toggle
						document.querySelector('.menu__filter-cc-container').classList.add('fading-out');
					}	

          			// Menus
					if ( $(returnedData.menus).length ) {
						$('#menus_ajax_container .menu').remove();
						$.when($('#menus_ajax_container .menu').remove()).then(content.append($(returnedData.menus)));
					}

					// Re-call JS functions
					initMenuSectionSlider();
					initTooltips();

					// Show the menuSections elem again
					menuSections.removeAttribute('style');
					menuSections.classList.remove('fading-out');

					content.removeAttr('style');
					content.removeClass('fading-out');
				},
				error : function (jqXHR, textStatus, errorThrown) {
					$(this).html($.parseJSON(jqXHR.responseText) + ' :: ' + textStatus + ' :: ' + errorThrown);
					console.log(jqXHR);
				},
			});
		}

		// Clear filters functions
		var clearFiltersTrigger = document.querySelector('.menu__filter-clear-btn');
		if ( clearFiltersTrigger ) {
			clearFiltersTrigger.addEventListener('click', (e) => {
				e.preventDefault();

				// Clear the filters
				clearFilters();

				// Update the mene items
				var menuItems = document.querySelectorAll('.menu__item.fade-out');

				if ( menuItems ) {
					menuItems.forEach(item => {
						item.classList.remove('fade-out');
					});
				}
			});
		}
    
		function clearFilters() {
			// Reset filter vars
			activeFilterSection = 'allergens';
			minCalories = 0;
			maxCalories = 0;
			dietaryFiltersArr = [];
			allergenFiltersArr = [];

			// Remove active state from any active filters
			var activeFilters = document.querySelectorAll('.menu__filter-link.active');
			if ( activeFilters ) {
				activeFilters.forEach(filter => {
				filter.classList.remove('active');
				});
			}

			// Reset selectric values
			$('.js__selectric--diet').prop('selectedIndex', 0).selectric('refresh');
			$('.js__selectric--allergens').prop('selectedIndex', 0).selectric('refresh');

			// Rest Calories Range
			var calorieRangeElem = document.querySelector('.js__calorie-range');
			if ( calorieRangeElem ) {
				calorieRangeElem.noUiSlider.reset();
			}
		}

		// Check when the menus section is sticky
		const observer = new IntersectionObserver( 
			([e]) => e.target.classList.toggle('is-pinned', e.intersectionRatio < 1),
			{rootMargin: '-' + (getHeaderHeight() + 1) + 'px 0px 0px 0px', threshold: [1]}
		);
		observer.observe(document.querySelector('.menu__sections-list'));

		function getHeaderHeight() {
			var header = document.querySelector('header.header');
			var headerHeight = header.offsetHeight;

			return parseInt(headerHeight);
		}
	}

	// Gallry Grid
	const lightbox = GLightbox({
	    touchNavigation: true,
	    loop: true
	});

	var $grid = $('.gallery__grid').masonry({
  		columnWidth: '.gallery__sizer',
  		gutter: '.gallery__gutter',
  		itemSelector: '.gallery__grid-item'
	});
	
	$grid.imagesLoaded().progress( function() {
		$grid.masonry('layout');
	});	

	$(document).on('click', '.js__gallery-load-more', function(e) {
		e.preventDefault();

		var start = $('.gallery__grid-item').length;
		var id = $(this).data('id');
		var field = $(this).data('field');
		var total = $(this).data('total');

		ajaxGalleryImages(start, id, field, total);
	});

	function ajaxGalleryImages(start, id, field, total) {
		var btnText = $('.js__gallery-load-more').text();

	    $.ajax({
	        type: 'POST',
	        dataType: 'html',
	        url: main__js_vars.ajaxurl,
	        data: {
	            'start': start,
	            'number_to_show': 16,
	            'id': id,
	            'field': field,
	            'total': total,
	            'action': 'gallery_items'
	        },
	        beforeSend : function () {
	            $('.js__gallery-load-more').text('Loading...');
	        },
	        success: function (data) {
	            var returnedData = JSON.parse(data);

	            if ( !returnedData.show_button ) {
	            	$('.js__gallery-load-more').fadeOut();
	            } else {
	            	$('.js__gallery-load-more').text(btnText);
	            }

	            if ($(returnedData.images).length) {
					var $content = $(returnedData.images);
					$grid.append($content).imagesLoaded(function(){
					    $grid.masonry( 'appended', $content, true );
						const lightbox = GLightbox({
						    touchNavigation: true,
						    loop: true
						});					    
					});					
	            }
	        },
	        error : function (jqXHR, textStatus, errorThrown) {
	            $(this).html($.parseJSON(jqXHR.responseText) + ' :: ' + textStatus + ' :: ' + errorThrown);
	            console.log(jqXHR);
	        },
	    }); 
	}	

	// Booking Type Trigger
	$(document).on('click', '.booking__section-option', function(e) {
		e.preventDefault();

		var content = $('.booking__section');

	    // Set min height for the content
	    var minHeight = content.outerHeight();
	    content.css('min-height', minHeight+'px');	

		$('.booking__section-options').fadeOut(400);

		setTimeout(function() {			
			$('.booking__section .booking-form__widget-container').fadeIn();
			content.removeAttr('style');
		}, 550);
	});

	// Parallax
	if ( $('.parallax-object').length ) {
		$('.parallax-object').each(function() {
			parallax($(this), 10);
		});
	}

	if ( $('.hero__section-subheading-container').length ) {
		$('.hero__section-subheading-container').each(function() {
			parallax($(this), 12);
		});
	}

	function parallax(elem, speed=12, reverse=false) {
		var initialPosition = (elem.offset().top) / speed;
		elem.css('transform', 'translateY('+initialPosition+'px)');

		$(window).on('resize scroll', function() {
			var scroll = $(window).scrollTop();
			var distance = initialPosition - (scroll / speed);

			if ( reverse ) {
				distance = initialPosition + (scroll / speed);
			}

			var window_width = $(window).width();

			if ( window_width > 767 ) {
	      		$(elem).css('transform', 'translateY('+distance+'px)');
	    	} else {
	    		$(elem).removeAttr('style');
	    	}	
		});
	}

	// Reveal Images
	$('.js__reveal-image').each(function() {
		var elem = $(this);
		var elemTopPosition = elem.offset().top;
		var offset = elem.height() / 4;
		var elemTop = elemTopPosition + offset;
		var windowHeight = $(window).height();

		$(window).on('resize scroll', function() {
			var scroll = $(window).scrollTop();
			var screenBottom = scroll + windowHeight;

			if ( screenBottom > elemTop ) {
				elem.addClass('animate');
			}	
		});		
	});

	// Newsletter Signup
    function isValidEmailAddress(emailAddress) {
      var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
      return pattern.test(emailAddress);
    }

    function setFormWidth() {
    	var field = $('.footer__subscribe-col #acteol_signup_form .field');
    	var fieldCount = field.length;
    	var fieldWidth = field.first().width();
    	var formWidth = fieldCount * fieldWidth;
    	var mulitplier = parseInt($('.footer__subscribe-col #acteol_signup_form .field.active').attr('id') - 1);
    	var translateDistance = fieldWidth * mulitplier;

      	$('.footer__subscribe-col #acteol_signup_form').css('width', formWidth+'px');
      	$('.footer__subscribe-col #acteol_signup_form').css('transform', 'translateX(-'+translateDistance+'px)');
    }

    setFormWidth();
    $(window).on('resize', function() {
    	setFormWidth();
    });

	$('.field input').keydown(function (e) {
	    if ( e.keyCode == 13 ){
	        $('.field.active .next-button').trigger('click');
	    }
	});    

    $('.field .next-button').click(function() {
    	if ( $(this).hasClass('form-submit-btn') ) {
    		$('.footer__subscribe-col #acteol_signup_form').submit();
    	} else {
	      	var field = $(this).parent(),
	          	input_val = field.find('input').val();

	        if ( field.hasClass('dob') ) {
	        	input_val = 'dob';
	        }

	  		if (input_val === '') {
	      		field.find('.error').css('display', 'block');
	      	} else if(field.find('input').attr('id') === 'emailaddress' && !isValidEmailAddress(input_val)) {
		      	field.find('.error').css('display', 'none');
		        field.find('.valid-email-address-error').css('display', 'block');
			} else if(field.find('input').attr('id') === 'allow_contact' && field.find('input:checked').length <= 0) {
				field.find('.error').css('display', 'block');
			} else if(field.find('input').attr('id') === 'privacy' && field.find('input:checked').length <= 0) {
				field.find('.error').css('display', 'block');
			} else {
				field.find('.error').css('display', 'none');

				var mulitplier = field.attr('id'),
	          		field_length = $('.field').width(),
	          		distance = mulitplier * field_length;

	        	$('.footer__subscribe-col #acteol_signup_form').css('transform', 'translateX(-'+distance+'px)');
	        	$('.field').removeClass('active');
	        	field.next('.field').addClass('active');
	      	}      
    	}
    });	

    $('.footer__subscribe-col #acteol_signup_form').on('submit', function(e) {
    	e.preventDefault();
    	var content = $('.footer__subscribe-col .form-holder');
    	var minHeight = $('.footer__subscribe-col .form-holder .field.active').outerHeight();

    	var formData = $(this).serialize();

	    $.ajax({
	        type: 'POST',
	        dataType: 'html',
	        url: main__js_vars.ajaxurl,
	        data: formData + '&action=newsletter_signup',
	        beforeSend : function () {
	        	content.css('min-height', minHeight+'px');
	        	$('.footer__subscribe-col #acteol_signup_form').fadeOut();

	        	setTimeout(function(e) {
	        		$('.footer__subscribe-col .submit-message').fadeIn();
	        	}, 550);
	        },
	        success: function (data) {
	            var returnedData = JSON.parse(data);

	            console.log(returnedData);
	            console.log(returnedData.response.message);
	            $('.footer__subscribe-col .submit-message').addClass('fade-out');

	            setTimeout(function(e) {
	            	$('.footer__subscribe-col .submit-message').text(returnedData.response.message);
	            	$('.footer__subscribe-col .submit-message').removeClass('fade-out');
	            }, 450);
	        },
	        error : function (jqXHR, textStatus, errorThrown) {
	            $(this).html($.parseJSON(jqXHR.responseText) + ' :: ' + textStatus + ' :: ' + errorThrown);
	            console.log(jqXHR);
	        },
	    }); 
    });

    // Fade in animations
    $(window).on('scroll', function() {
        animateSection();
    });
    $(window).trigger('scroll');

    function animateSection() {
        var windowTop = $(window).scrollTop();
        var windowBottom = windowTop + $(window).height();

        $('.anim__elem').each(function() {
            var offset = 40;
            var elementTop = $(this).offset().top + offset;
            var fadeType = $(this).data('fade-type');

            if ( windowBottom > elementTop ) { // Section is in view
                $(this).addClass('in-view');
            }
        });
	} 
	
	// Cookie Helpers
	function setCookie(name, value, days, path) {
		var expires = "";
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + (value || "") + expires + "; path=/" + path;
	}
	function getCookie(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	}

    // Star Cursor
    var cursorElem = document.querySelector('.c-cursor');

    if ( cursorElem ) {
		// Show Star Animation
		document.addEventListener("mousemove", moveMouse);

		// Hover effect.
		var hoverElems = 'a, .selectric, .selectric-items li, input, textarea, select, .noUi-connects, .noUi-origin, .js-hov, .slick-dots, .slick-arrow, .overflow-slider-arrows__arrow, iframe, #acteol_signup_form .next-button';

		$(document).on('mouseenter', hoverElems, function() {
			gsap.to('.c-cursor', {
				duration: .35,
				opacity: 0,
			});
		});

		$(document).on('mouseleave', hoverElems, function() {
			gsap.to('.c-cursor', {
				duration: .35,
				opacity: 1,
			});
		});
    }

    function moveMouse(event) {
		gsap.to(".c-cursor__star", {
			x: event.clientX,
			y: event.clientY,
			stagger: 0.1
		});
    }	
}